import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  HowToPlayModalOverlay: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 1200px)": {
      overflow: 'auto !important'
    }
  },
  HowToPlayModal: {
    backgroundColor: "#FFFFFF",
    maxWidth: 1020,
    width: "100%",
    margin: "auto",
    boxShadow: "none !important",
    outline: "none",
    borderRadius: 8,
    "@media (max-width: 1200px)": {
      "&.ReactModal__Content.ReactModal__Content--after-open": {
        borderRadius: "0 !important",
        maxWidth: "100%"
      }
    }
  },
  HowToPlayModalHeader: {
    paddingTop: 24,
    paddingRight: 48,
    paddingLeft: 48,
    position: "relative",
    "@media (max-width: 1200px)": {
      paddingRight: 32,
      paddingLeft: 32
    },
    "@media (max-width: 600px)": {
      paddingRight: 24,
      paddingLeft: 24
    }
  },
  HowToPlayModalHeaderTitle: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.6
  },
  HowToPlayModalHeaderCloseBtn: {
    width: 28,
    height: 28,
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.17508 6.17569C6.63069 5.72008 7.36939 5.72008 7.825 6.17569L21.825 20.1757C22.2806 20.6313 22.2806 21.37 21.825 21.8256C21.3694 22.2812 20.6307 22.2812 20.1751 21.8256L6.17508 7.82561C5.71947 7.37 5.71947 6.6313 6.17508 6.17569Z' fill='%23818699'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.825 6.17569C21.3694 5.72008 20.6307 5.72008 20.1751 6.17569L6.17508 20.1757C5.71947 20.6313 5.71947 21.37 6.17508 21.8256C6.63069 22.2812 7.36939 22.2812 7.825 21.8256L21.825 7.82561C22.2806 7.37 22.2806 6.6313 21.825 6.17569Z' fill='%23818699'/%3E%3C/svg%3E%0A\")",
    border: "none",
    backgroundColor: "transparent",
    backgroundSize: 24,
    backgroundPosition: "center",
    position: "absolute",
    right: 20,
    top: 26,
    cursor: "pointer"
  },
  HowToPlayModalBody: {
    paddingTop: 24,
    paddingRight: 48,
    paddingBottom: 8,
    paddingLeft: 48,
    "@media (max-width: 1200px)": {
      paddingLeft: 32,
      paddingRight: 32,
      paddingBottom: 0
    },
    "@media (max-width: 600px)": {
      paddingLeft: 24,
      paddingRight: 24
    }
  },
  HowToPlayItems: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0 -24px"
  },
  HowToPlayItem: {
    width: "33.3%",
    padding: "0 24px",
    marginBottom: 40,
    "@media (max-width: 1200px)": {
      width: "50%"
    },
    "@media (max-width: 600px)": {
      width: "100%"
    }
  },
  HowToPlayItemImg: {
    width: "100%"
  },
  HowToPlayItemTitle: {
    fontSize: 15,
    fontWeight: 600,
    lineHeight: 1.4,
    color: "#333333",
    marginTop: 24
  },
  HowToPlayItemDescription: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.4,
    color: "#333333",
    marginTop: 8,
    "& ul": {
      "& li": {
        marginTop: 8,
        listStyle: "none",
        position: "relative",
        paddingLeft: 24,
        "&:before": {
          content: '"\\2022"',
          position: "absolute",
          top: 9,
          left: 9,
          fontSize: 18,
          lineHeight: 0
        }
      }
    }
  }
});
